import { CircularProgress, Grid, Paper, Typography } from "@material-ui/core";
import LabelsContext from "../../../../lang/LabelsContext";
import TicketDto from "../../../../model/ticket/TicketDto";
import TicketsService, { TicketsServiceType } from "../../../../service/tickets/TicketService";
import TicketCard from "../card/TicketCard";
import { useStyles, Accordion, AccordionSummary, AccordionDetails } from "../TicketStyle";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

export default function TicketListReview() {
  const { Labels } = LabelsContext();
  const classes = useStyles();
  const {
    ticketAwaitReviewList,
    ticketOpenReviewList,
    ticketClosedReviewList,
    expanded,
    handleChange,
    ticketDelete,
  }: TicketsServiceType = TicketsService();

  const accordionDetailsComponent = (array: Array<TicketDto>) => {
    if (!array) {
      return <CircularProgress color="primary" />;
    }
    if (array.length === 0) {
      return <Typography color="textSecondary">{Labels.NO_RESULTS}</Typography>;
    }
    return (
      <Grid container direction="row" justifyContent="flex-start" spacing={3}>
        {array.map((ticket: TicketDto, i: number) => {
          return (
            <Grid item key={i} xs={3}>
              <TicketCard
                key={ticket.id}
                status={ticket.status}
                name={ticket.name}
                id={ticket.id}
                ticket={ticket}
                date={ticket.date}
                ticketDelete={ticketDelete}
                type={ticket.type}
              />
            </Grid>
          );
        })}
      </Grid>
    );
  };

  return (
    <Paper className={classes.paper}>
      <Accordion square expanded={expanded.accordion1} onChange={handleChange("accordion1")}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">{Labels.TICKETS_ANSWERING}</Typography>
        </AccordionSummary>
        <AccordionDetails>{accordionDetailsComponent(ticketAwaitReviewList)}</AccordionDetails>
      </Accordion>
      <Accordion square expanded={expanded.accordion2} onChange={handleChange("accordion2")}>
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header" expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">{Labels.PENDING_TICKETS}</Typography>
        </AccordionSummary>
        <AccordionDetails>{accordionDetailsComponent(ticketOpenReviewList)}</AccordionDetails>
      </Accordion>
      <Accordion square expanded={expanded.accordion3} onChange={handleChange("accordion3")}>
        <AccordionSummary aria-controls="panel3d-content" id="panel3d-header" expandIcon={<ExpandMoreIcon />}>
          <Typography variant="h6">{Labels.CLOSED_TICKET}</Typography>
        </AccordionSummary>
        <AccordionDetails>{accordionDetailsComponent(ticketClosedReviewList)}</AccordionDetails>
      </Accordion>
    </Paper>
  );
}
